module.exports = __webpack_public_path__ + "img/share.585f1880.svg";